import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { MobileAddOnCustomize } from "./component";
import {
  isCfarAvailableInChosenRoomProductSelector,
  cancellationPolicyFromChosenRoomProductV2Selector,
  selectStandaloneCfarQuoteFromChosenRoomProduct,
  getRefundableRoomProductCorrespondingToChosenRoom,
} from "../../../../shop/reducer";
import { IStoreState } from "../../../../../reducers/types";

const mapStateToProps = (state: IStoreState) => ({
  isCfarAvailable: isCfarAvailableInChosenRoomProductSelector(state),
  cfarQuoteV2: selectStandaloneCfarQuoteFromChosenRoomProduct(state),
  cancellationPolicy: cancellationPolicyFromChosenRoomProductV2Selector(state),
  refundableRoomProductCorrespondingToChosenRoom:
    getRefundableRoomProductCorrespondingToChosenRoom(state),
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileAddOnCustomizeConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileAddOnCustomize = withRouter(
  connector(MobileAddOnCustomize)
);
